/**
 * The module host serves course content and the LRS from the API. The user app must never render there
 * alongside third-party course code. A UI-routing hint only: the API's MODULE_HOSTS gate is the boundary.
 */
const isModulesLabel = (label: string): boolean => label === 'modules' || /^modules-[a-z0-9]+$/.test(label);

const stripPort = (host: string): string => {
    const colon = host.indexOf(':');
    return colon === -1 ? host : host.slice(0, colon);
};

export const isModulesHost = (host: string = typeof window === 'undefined' ? '' : window.location.host): boolean => {
    const labels = stripPort(host.trim().toLowerCase()).split('.');
    return labels.length > 1 && isModulesLabel(labels[0]);
};

/** The user app's origin, from the module host: drop a `modules` label or strip a `modules-` prefix. */
export const userAppOriginFromModulesHost = (location: Location = window.location): string => {
    const [first, ...rest] = location.host.split('.');
    const env = first.toLowerCase().startsWith('modules-') ? first.slice('modules-'.length) : null;
    return `${location.protocol}//${[...(env ? [env] : []), ...rest].join('.')}`;
};
